import { BigNumber } from '@ethersproject/bignumber';

import { humanizeBn } from 'tools/math';

import { formatNumberToLocale } from './formatNumberToLocale';

const calculateFix = (amount: string): number => {
  const integer = Number(amount.split('.')[0]);

  if (isNaN(integer)) return 6;

  if (Math.abs(integer) < 5) return 6;

  if (Math.abs(integer) < 50) return 4;

  if (Math.abs(integer) < 500) return 3;

  if (Math.abs(integer) < 5000) return 2;

  return 0;
};

interface IFormatTokenOptions {
  precision?: number;
}

export const formatToken = (
  bn: BigNumber,
  decimals = 18,
  options?: IFormatTokenOptions,
): string => {
  const stringAmount = humanizeBn(bn, decimals);

  const fix = options?.precision !== undefined ? options.precision : calculateFix(stringAmount);

  return formatNumberToLocale(stringAmount, fix);
};
